import { Heading3 } from '@lightspeed/flame/Text';
import { Box, Flex } from '@lightspeed/flame/Core';
import { LabelRequired } from '../custom/LabelRequired';
import { Autocomplete } from '../fields';
import { useTranslation } from 'react-i18next';
import useAccounts from '../../hooks/useAccounts';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';

export const MapAccountPayment = () => {
  const [isLoading, accountsList] = useAccounts('giftCard');
  const { t } = useTranslation();
  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();

  return <Box padding="0.75rem">
    <Heading3 mb="0.375rem">Account Payment</Heading3>
    <Flex>
      <Box width="49%" pr="1.1rem">
        <LabelRequired htmlFor="accountPayment">
          {
            t(isInputsOnlyLayout ? 'Enter Account Payment account' : 'Select a Account Payment account')
          } 
        </LabelRequired>
        <Autocomplete
          isLoadingOptions={isLoading}
          id="onAccountAccount"
          name="onAccountAccount"
          options={accountsList}
          placeholder={
            t(isInputsOnlyLayout ? 'Enter Account Payment account' : 'Select an account')
          }
        />
      </Box>
    </Flex>
  </Box>;
};
